/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {translate} from '@ion/core/src/locale/locale';

export const getMemberCount = (members: any[]) => {
  let deviceCount = 0;
  let assetCount  = 0;
  members?.map((item) => {
    if (item.type === 'device') {
      deviceCount = item.count;
    }

    if (item.type === 'asset') {
      assetCount = item.count;
    }
  });
  return translate('groups:grid.itemCount', {assetCount, deviceCount});
};
